// frontend/src/utils/richText.js
// Client-side mirror of backend/src/utils/sanitizeHtml.js. This is
// defense-in-depth for rendering -- the server re-sanitizes on save, which
// is the real boundary since a comment can be read by every other user.
import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
    'p', 'br', 'span', 'strong', 'b', 'em', 'i', 'u', 's', 'strike', 'sub', 'sup',
    'a', 'ul', 'ol', 'li', 'blockquote', 'h1', 'h2', 'h3', 'h4',
    'table', 'thead', 'tbody', 'tr', 'td', 'th', 'figure', 'figcaption', 'img',
];

const ALLOWED_ATTR = [
    'href', 'target', 'rel', 'src', 'alt', 'width', 'height',
    'style', 'colspan', 'rowspan', 'class',
];

export function sanitizeCommentHtml(html) {
    return DOMPurify.sanitize(String(html ?? ''), { ALLOWED_TAGS, ALLOWED_ATTR });
}

/** True once tags/whitespace are stripped -- an "empty" CKEditor doc is often "<p>&nbsp;</p>". */
export function isBlankHtml(html) {
    return String(html ?? '')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .trim() === '';
}
